import api from "@services/api-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    SET_ASSOCIACAO_LOADING: (state, isLoading) => {
      state.associacao.loading = isLoading;
    },

    SET_ASSOCIACAO: (state, associacao) => {
      state.associacao.data = associacao;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    getAssociacoes: state => id => {
      if (id) {
        let associacao = state.associacao.data.filter(
          associacao => associacao.id == id
        );

        return associacao.length > 0 ? associacao[0] : null;
      }

      return state.associacao.data;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_ASSOCIACAO({ commit }) {
      commit("SET_ASSOCIACAO_LOADING", true);
      api()
        .get("associacao")
        .then(response => {
          if (response.data.status) {
            commit("SET_ASSOCIACAO", response.data.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_ASSOCIACAO_LOADING", false));
    }
  }
};

export default store;
